"use client";
import React from "react";

interface CustomRangeBarProps {
  label?: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  unit?: string;
  labelStyle?: string;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export default function CustomRangeBar({ label, labelStyle, value, min, max, step = 1, unit = "", onChange, disabled = false }: CustomRangeBarProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value));
  };

  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className="w-full">
      {label && <p className={labelStyle}>{label}</p>}
      <label className="flex items-center gap-4">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleChange}
          style={{
            background: `linear-gradient(to right, #1f66c1 0%, #1f66c1 ${percentage}%, #f2f6fc ${percentage}%, #f2f6fc 100%)`,
          }}
          disabled={disabled}
          className={`w-full h-1.5 rounded-lg appearance-none focus:outline-hidden
            [&::-webkit-slider-thumb]:appearance-none 
            [&::-webkit-slider-thumb]:w-4 
            [&::-webkit-slider-thumb]:h-4 
            [&::-webkit-slider-thumb]:bg-white 
            [&::-webkit-slider-thumb]:border-[3px] 
            [&::-webkit-slider-thumb]:border-solid 
            [&::-webkit-slider-thumb]:border-primaryBlue 
            [&::-webkit-slider-thumb]:rounded-full 
            [&::-webkit-slider-thumb]:cursor-pointer
            [&::-moz-range-thumb]:appearance-none
            [&::-moz-range-thumb]:w-4 
            [&::-moz-range-thumb]:h-4 
            [&::-moz-range-thumb]:bg-white 
            [&::-moz-range-thumb]:border 
            [&::-moz-range-thumb]:border-primaryBlue 
            [&::-moz-range-thumb]:rounded-full 
            [&::-moz-range-thumb]:cursor-pointer
            [&::-ms-thumb]:appearance-none`}
        />
        <span className="text-black text-sm font-medium shrink-0">
          {value} {unit}
        </span>
      </label>
    </div>
  );
}
